import { stampCardSorterAtom } from '@activities/membership/stamp/StampsActivity/atoms/stampAtoms';
import BottomSheetHeader from '@components/BottomSheetHeader';
import Column from '@components/Column';
import Radio from '@components/Radio';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { StampCardSorter } from '@models/stamp';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        StampSortBottomSheet: {};
    }
}

const StampSortBottomSheet: ActivityComponentType<'StampSortBottomSheet'> = () => {
    const { t } = useTranslation('stamp');
    const [sort, setSort] = useAtom(stampCardSorterAtom);
    return (
        <BottomSheet>
            <BottomSheetHeader>
                {t('filter.title')}
            </BottomSheetHeader>
            <Container spacing={8} fullWidth>
                <Text fontWeight='bold'>{t('filter.title')}</Text>
                <Column fullWidth >
                    <RadioWrapper>
                        <Radio value=''
                            isSelected={sort === StampCardSorter.IssuedAtDesc}
                            onChange={() => setSort(StampCardSorter.IssuedAtDesc)}
                        >
                            {t('filter.recentOrder')}
                        </Radio>
                    </RadioWrapper>
                    <RadioWrapper>
                        <Radio value=''
                            isSelected={sort === StampCardSorter.ShopNameAsc}
                            onChange={() => setSort(StampCardSorter.ShopNameAsc)}
                        >
                            {t('filter.alphabetOrder')}
                        </Radio>
                    </RadioWrapper>
                </Column>
            </Container>
        </BottomSheet>
    );
};

const Container = styled(Column)`
    padding: 16px 16px calc(16px +  var(--safe-area-bottom));
`;

const RadioWrapper = styled.div`
    padding: 8px 0
`;

export default StampSortBottomSheet;
